import {
  postSurgeryDummyColumn,
  addDummyColumns,
} from '@common/components/table/SurgeryGridHelpers';
import {
  VisitAnesthesiaFormPostSurgeryVitalModel,
  IVisitAnesthesiaFormPostSurgeryVitalModel,
  IModel,
  Model,
  ModelRecord,
} from '@common/models';
import { DateTime } from 'luxon';

export interface IVisitAnesthesiaFormPostSurgeryModel extends IModel {
  visitAnesthesiaFormPostSurgeryId: number;
  startTime: string | undefined;
  stopTime: string | undefined;
  timeOfExtubation: string;
  qualityOfRecovery: string;
  surgeryNote: string;
  vitals: IVisitAnesthesiaFormPostSurgeryVitalModel[];
  dateCreated: string;
  dateUpdated: string;
  userUpdatedTitle: string;
  userUpdatedFirstName: string;
  userUpdatedLastName: string;
}

export class VisitAnesthesiaFormPostSurgeryModel
  extends Model
  implements ModelRecord<IVisitAnesthesiaFormPostSurgeryModel>
{
  visitAnesthesiaFormPostSurgeryId: number;
  startTime: string;
  stopTime: string;
  timeOfExtubation: string;
  qualityOfRecovery: string;
  surgeryNote: string;
  vitals: VisitAnesthesiaFormPostSurgeryVitalModel[] = [];
  dateCreated: DateTime;
  dateUpdated: DateTime;
  userUpdatedTitle: string;
  userUpdatedFirstName: string;
  userUpdatedLastName: string;
  vitalsLength: number;

  constructor(params?: Partial<IVisitAnesthesiaFormPostSurgeryModel>) {
    super(params);
    this.visitAnesthesiaFormPostSurgeryId = _.defaultTo(
      params?.visitAnesthesiaFormPostSurgeryId,
      0,
    );
    this.startTime = _.defaultTo(params?.startTime, '');
    this.stopTime = _.defaultTo(params?.stopTime, '');
    this.timeOfExtubation = _.defaultTo(params?.timeOfExtubation, '');
    this.qualityOfRecovery = _.defaultTo(params?.qualityOfRecovery, '');
    this.surgeryNote = _.defaultTo(params?.surgeryNote, '');
    this.vitalsLength = params?.vitals?.length || 0;
    _.map(params?.vitals, (m) => {
      this.vitals.push(new VisitAnesthesiaFormPostSurgeryVitalModel(m));
    });
    this.vitals = [
      ...addDummyColumns(this.vitals.length, postSurgeryDummyColumn),
      ...this.vitals,
    ];
    if (!this.stopTime && this.vitalsLength >= 25) {
      this.vitals.push(postSurgeryDummyColumn(this.vitalsLength + 1));
    }
    this.vitals.sort((a, b) => Number(a.interval) - Number(b.interval));
    this.dateCreated = params?.dateCreated
      ? DateTime.fromISO(params.dateCreated, { zone: 'utc' })
      : DateTime.min();
    this.dateUpdated = params?.dateUpdated
      ? DateTime.fromISO(params.dateUpdated, { zone: 'utc' })
      : DateTime.min();
    this.userUpdatedTitle = _.defaultTo(params?.userUpdatedTitle, '');
    this.userUpdatedFirstName = _.defaultTo(params?.userUpdatedFirstName, '');
    this.userUpdatedLastName = _.defaultTo(params?.userUpdatedLastName, '');
  }
}
